import { SnackBarComponent } from './snackbar';
export const SnackBar = SnackBarComponent;